import axios from 'axios'

const instance = axios.create()

const sendData = ({ data }) => data

const get = (endpoint, params = {}) => instance.get(`https://bd.datalesson.ru/api/students/${endpoint}`, { params })
  .then(sendData)

// session_id
// score: int (1-3)
// attempts_num: int
// time_spent: int
// additional_info: json array
// eslint-disable-next-line no-unused-vars
const saveResults = (data) => {
  // instance.post('https://xn--h1adlhdnlo2c.xn--p1ai/trainer/webhook', data)
  const form = document.createElement('form')
  form.method = 'post'
  form.action = 'https://xn--h1adlhdnlo2c.xn--p1ai/trainer/webhook'
  // form.action = 'https://new-1.datalesson.ru/certificate/neural-networks-and-communications/'
  form.style.visibility = 'hidden'
  form.style.position = 'absolute'

  Object
    .keys(data)
    .forEach((key) => {
      const value = data[key]
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = value
      form.appendChild(input)
    })

  document.body.appendChild(form)
  form.submit()
}

const saveResultsBackground = data => instance.post('https://xn--h1adlhdnlo2c.xn--p1ai/trainer/webhook', data)

export default {
  get,
  saveResults,
  saveResultsBackground,
  getData: params => get('', params),
}
